import type { FunctionComponent } from "react";
import { WalletTransactionDetailsSliderAdminPartial } from "../../../../partials/admin/menus/wallet-transactions/wallet-transaction-details-slider.admin.partials";

export const WalletTransactionDetailsSliderAdminScreen: FunctionComponent =
	() => {
		return <WalletTransactionDetailsSliderAdminPartial />;
	};
